import React, { Fragment } from 'react';
import classnames from 'classnames';
import { Button, Text } from '@BICE_Vida/components';

import Image from 'next/image';
import { Container, Card } from '../../designSystem';

import styles from './Banner.module.scss';
import stylesCard from '../../designSystem/Card/Card.module.scss';

type BannerT = {
  id: string;
  img: string;
  callToAction?: {
    id: string;
    text: string;
    onClick: () => void;
    icon?: string;
    iconFirst?: boolean;
  };
  title?: string;
  description: string;
  theme?: 'primary' | 'secondary';
  className?: string;
};

function Banner({
  id,
  img,
  callToAction,
  title,
  description,
  theme = 'primary',
  className,
}: BannerT) {
  const bannerClass = classnames(styles.banner_card, stylesCard.card_mobile, {
    [styles[`banner_theme_${theme}`]]: theme,
    [`${className}`]: className,
  });

  return (
    <Container className={styles.banner_container}>
      <Card id={id} customClass={bannerClass}>
        <Fragment>
          <div className={styles.banner_card_container}>
            <div className={styles.banner_image_container}>
              <Image src={img} width={186} height={331} alt="" />
            </div>
            <div className={styles.banner_card_content}>
              <div className={styles.banner_description_container}>
                {title && (
                  <Text className={styles.banner_title} fontTypo="title-medium" tag="h3">
                    {title}
                  </Text>
                )}
                {description && <Text className={styles.banner_description}>{description}</Text>}
              </div>

              {!!callToAction && (
                <div className={styles.btn_container}>
                  <Button
                    id={callToAction.id}
                    text={callToAction.text}
                    size="large"
                    onClick={callToAction.onClick}
                    icon={callToAction.icon}
                    iconPosition={callToAction.iconFirst ? 'left' : 'right'}
                    variant={theme === 'primary' ? 'primary' : 'text'}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={styles.circles_container}>
            <div className={`${styles.circles_background} ${styles.circle_one}`} />
            <div className={`${styles.circles_background} ${styles.circle_three}`} />
          </div>
        </Fragment>
      </Card>
    </Container>
  );
}

export default Banner;
